<template>
  <b-modal
    hide-footer
    size="xl"
    id="addressIntervention-create-modal"
    :title="$t('Create') + ' ' + $t('a.addressIntervention')"
  >
    <b-form @submit.stop.prevent="onSubmit">

      <!--          region adresse-->
      <b-form-group
        id="address-input"
        :label="$t('addressIntervention.address')+'*'"
        label-for="address-input"
        class="bold-label"
        :invalid-feedback="form.address.invalidFeedback"
        :state="form.address.state"
      >
        <b-form-input
          id="address-input"
          :placeholder="$t('number.and.address')"
          v-model="form.address.value"
          type="text"
          maxlength="250"
          :state="form.address.state"
          required
        ></b-form-input>
      </b-form-group>

      <b-form-group
        id="additionalAddress-input"
        :label="$t('addressIntervention.AdditionalAddress')"
        label-for="additionalAddress-input"
        class="bold-label"
        :invalid-feedback="form.additionalAddress.invalidFeedback"
        :state="form.additionalAddress.state"
      >
        <b-form-input
          id="additionalAddress-input"
          :placeholder="$t('addressIntervention.AdditionalAddress')"
          v-model="form.additionalAddress.value"
          type="text"
          maxlength="250"
          :state="form.additionalAddress.state"
        ></b-form-input>
      </b-form-group>

      <b-form-group
        id="postalCode-input"
        :label="$t('addressIntervention.postalCode')+'*'"
        label-for="postalCode-input"
        class="bold-label"
        :invalid-feedback="form.postalCode.invalidFeedback"
        :state="form.postalCode.state"
      >
        <b-form-input
          id="postalCode-input"
          :placeholder="$t('addressIntervention.postalCode')"
          v-model="form.postalCode.value"
          type="number"
          maxlength="5"
          :state="form.postalCode.state"
          no-wheel
          required
        ></b-form-input>
      </b-form-group>

      <b-form-group
        id="city-input"
        :label="$t('addressIntervention.city')+'*'"
        label-for="city-input"
        class="bold-label"
        :invalid-feedback="form.city.invalidFeedback"
        :state="form.city.state"
      >
        <b-form-input
          id="city-input"
          :placeholder="$t('addressIntervention.city')"
          v-model="form.city.value"
          type="text"
          maxlength="250"
          :state="form.city.state"
          required
        ></b-form-input>
      </b-form-group>
      <!--endregion-->
      <!--          region clients-->
      <div>
        <div class="card-subtitle main-color mt-3">{{$t('Join.clients.to.this.address')}}</div>
        <div class="mb-2">{{ $t('client.is.necessary') }}</div>
      </div>

      <div class="row">
        <div class="col-8">
          <b-form-group
            id="tenant-input"
            :label="$t('Tenant')"
            label-for="tenant-input"
            class="bold-label"
            :invalid-feedback="form.tenant.invalidFeedback"
            :state="form.tenant.state"
          >
            <auto-complete-input
              id="tenant-input"
              :placeholder="$t('tenant.select')"
              :options="clientOptions"
              @didSelect="didSelectTenant"
            />
          </b-form-group>
        </div>

        <div class="col-4 d-flex align-items-end">
          <b-form-group :label="$t('Client.doesnt.exist')">
            <b-button type="button" variant="thirdly" @click="showCreateClientModal('tenant')">+ {{$t('Create') + " " + $t('a.client') + " " + $t('tenant')}} </b-button>
          </b-form-group>
        </div>

      </div>

      <div class="row">
        <div class="col-8">
          <b-form-group
            id="owner-input"
            :label="$t('Owner')"
            label-for="owner-input"
            class="bold-label"
            :invalid-feedback="form.owner.invalidFeedback"
            :state="form.owner.state"
          >
            <auto-complete-input
              id="owner-input"
              :placeholder="$t('owner.select')"
              :options="clientOptions"
              @didSelect="didSelectOwner"
            />
          </b-form-group>
        </div>
        <div class="col-4 d-flex align-items-end">
          <b-form-group label=" ">
            <b-button type="button" variant="thirdly" @click="showCreateClientModal('owner')">+ {{$t('Create') + " " + $t('a.client') + " " + $t('owner')}} </b-button>
          </b-form-group>
        </div>
      </div>

      <div class="row">
        <div class="col-8">
          <b-form-group
            id="agency-input"
            :label="$t('Agency')"
            label-for="agency-input"
            class="bold-label"
            :invalid-feedback="form.agency.invalidFeedback"
            :state="form.agency.state"
          >
            <auto-complete-input
              id="agency-input"
              :placeholder="$t('agency.select')"
              :options="agencyOptions"
              @didSelect="didSelectAgency"
            />
          </b-form-group>
        </div>
        <div class="col-4 d-flex align-items-end">
          <b-form-group label=" ">
            <b-button type="button" variant="thirdly" @click="showCreateClientModal('agency')">+ {{$t('Create') + " " + $t('a.client') + " " + $t('agency')}} </b-button>
          </b-form-group>
        </div>
      </div>
      <!--endregion-->
      <div class="d-flex justify-content-end" v-if="!hideSendButton">
        <b-button type="submit" variant="primary">{{ $t('Validate') }}</b-button>
      </div>
    </b-form>
    <Client-create-modal :clientType="modalClientType" @didCreateClient="didCreateClient"></Client-create-modal>
    <AddressInterventionErrorModal :message="$t('client.mandatory.to.create.address')"></AddressInterventionErrorModal>


  </b-modal>

</template>

<script>

import api from '../../services/api';
import ClientCreateModal from "../client/ClientCreateModal";
import AddressInterventionErrorModal from "./AddressInterventionErrorModal";
import AutoCompleteInput from "../../components/AutoCompleteInput";

export default {
  name: 'AddressInterventionCreateModal',

  emits: ['didCreateAddressIntervention'],

  components: {
    ClientCreateModal,
    AddressInterventionErrorModal,
    AutoCompleteInput
  },

  data() {
    return {
      clientOptions: [],
      agencyOptions: [],
      modalClientType: null,
      hideSendButton: false,
      form: {
        address:
          {
            state: null,
            invalidFeedback: null,
            value: null
          },
        additionalAddress:
          {
            state: null,
            invalidFeedback: null,
            value: null
          },
        postalCode:
          {
            state: null,
            invalidFeedback: null,
            value: null
          },
        city:
          {
            state: null,
            invalidFeedback: null,
            value: null
          },
        tenant:
          {
            state: null,
            invalidFeedback: null,
            value: null
          },
        owner:
          {
            state: null,
            invalidFeedback: null,
            value: null
          },
        agency:
          {
            state: null,
            invalidFeedback: null,
            value: null
          }
      }
    }
  },

  mounted() {
    this.fetchData()
  },

  methods: {

    fetchData(){
      this.fetchAgencies()
      this.fetchClients()
    },

    fetchAgencies(){
      api
        .get(`/client/getAllAgencies`)
        .then(response => {
          response.data.forEach(it => {
            this.agencyOptions.push({value: it.id, text:it.agencyName})
          })
        })
    },

    fetchClients(){
      api
        .get(`/client/getAllClients`)
        .then(response => {
          response.data.forEach(it => {
            this.clientOptions.push({value: it.id, text:it.name})
          })
        })
    },

    onSubmit() {
      if(this.form.tenant.value == null && this.form.owner.value == null && this.form.agency.value == null){
        this.$bvModal.show('addressIntervention-error-modal')
        return
      }

      let data = new FormData()
      data.append('address', this.form.address.value)
      if(this.form.additionalAddress.value && this.form.additionalAddress.value.trim() !== ""){
        data.append('additionalAddress', this.form.additionalAddress.value)
      }
      data.append('postalCode', this.form.postalCode.value)
      data.append('city', this.form.city.value)

      if(this.form.tenant.value){
        data.append('tenantId', this.form.tenant.value)
      }
      if(this.form.owner.value){
        data.append('ownerId', this.form.owner.value)
      }
      if(this.form.agency.value){
        data.append('agencyId', this.form.agency.value)
      }

      this.hideSendButton = true

      api({
        method: 'POST',
        url: `addressIntervention`,
        data: data
      })
        .then((response) => {
          this.successToast()
          this.$emit('didCreateAddressIntervention', response.data)
          this.hideSendButton = false
        })
        .catch((error) => {
          this.hideSendButton = false
          if(error.response != null){
            if (error.response.status === 418) {
              const invalidField = error.response.data.invalidField
              this.form[invalidField]["state"] = false
              this.form[invalidField]["invalidFeedback"] = error.response.data.message
            }
          }
        });
    },

    showCreateClientModal(modalClientType){
      this.modalClientType = modalClientType
      this.$bvModal.show('client-create-modal')
    },

    didCreateClient(response) {
      if(this.modalClientType === "agency"){
        this.agencyOptions.push(response)
        this.form.agency.value = response.value
      }else{
        this.clientOptions.push(response)
        if(this.modalClientType === "tenant"){
          this.form.tenant.value = response.value
        }else{
          this.form.owner.value = response.value
        }
      }
      this.$bvModal.hide('client-create-modal')
    },

    didSelectTenant(value){
      this.form.tenant.value = value
    },
    didSelectOwner(value){
      this.form.owner.value = value
    },
    didSelectAgency(value){
      this.form.agency.value = value
    },

    successToast() {
      this.$bvToast.toast(this.$i18n.t('AddressIntervention') + ' ' + this.$i18n.t('added'), {
        autoHideDelay: 2000,
        toaster: 'b-toaster-bottom-right',
        noCloseButton: true
      })
    },
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/addressIntervention/AddressInterventionCreateModal.vue